// extracted by mini-css-extract-plugin
export default {"root":"Badge_root__Dq78u","hasIcon":"Badge_hasIcon__cmo8H","circle":"Badge_circle__DHQUj","hideBg":"Badge_hideBg__sCJuV","dot":"Badge_dot__XJtnN","filled":"Badge_filled__wDGyZ"};